import { createFileRoute } from "@tanstack/react-router";
import AdminManufacturerEdit from "@/pages/admin/AdminManufacturerEdit";

export const Route = createFileRoute("/_adminLayout/admin/parts/manufacturers/$vendorId")({
  component: AdminManufacturerEdit,
});
